import { useServices } from 'services/useServices';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import { useAppMessages } from '../../../useAppMessages';
import { DecoderFilter } from '../../../../services/api/enmonTools';

export const useLogDecoder = (params: DecoderFilter) => {
  const messages = useAppMessages();
  const {
    enmonTools: {
      decoder: { getMessages },
    },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.enmonTools.decoder.getDecodedMessages(params),
    queryFn: async ({ signal }) => await getMessages(params, signal),
    onError: () =>
      messages.error({
        message: 'There was an error while fetching device messages',
      }),
    cacheTime: 0,
  });
};
